'use strict';

exports.__esModule = true;
exports.createFormRulesBySchema = createFormRulesBySchema;
exports.priceFormatter = priceFormatter;
exports.priceParser = priceParser;
exports.createElementByProperty = createElementByProperty;
exports.createFormatter = createFormatter;
exports.dateFormatter = dateFormatter;
exports.dateTimeFormatter = dateTimeFormatter;
exports.booleanFormatter = booleanFormatter;
exports.createDefaultObjectBySchema = createDefaultObjectBySchema;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _index = require('setaria-ui/lib/constants/index');

var _util = require('setaria-ui/lib/utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 根据Schema取得Property
 * @param {*} schema
 * @param {*} uiSchema
 * @returns
 */
function createFormRulesBySchema(schema, uiSchema) {
  var ret = {};
  var _schema$required = schema.required,
      required = _schema$required === undefined ? [] : _schema$required,
      _schema$properties = schema.properties,
      properties = _schema$properties === undefined ? {} : _schema$properties;
  // 优化当实时change schema.required时errorMessage未刷新的问题

  Object.keys(properties).forEach(function (key) {
    var item = properties[key];
    var itemName = '';
    if (item) {
      itemName = item.title;
    }
    ret[key] = [];
    if (required.includes(key)) {
      ret[key].push({
        required: true,
        message: '\u8BF7\u8F93\u5165' + itemName,
        trigger: 'blur'
      });
    }
  });
  // 文本框长度限制&类型
  Object.keys(properties).forEach(function (key) {
    var item = properties[key];
    var itemName = '';
    if (item) {
      itemName = item.title;
    }
    var uiSchemaItemObj = uiSchema[key];
    var customRules = uiSchemaItemObj && uiSchemaItemObj[_index.JSON_FORM_UI.UI_RULE];
    // 自定义rule
    if (customRules) {
      var originRule = ret[key];
      ret[key] = originRule.concat(customRules);
      // 根据schema生成的rule
    } else {
      if (!(0, _util.isEmpty)(item.pattern)) {
        var rule = {
          pattern: item.pattern,
          message: '\u8F93\u5165\u683C\u5F0F\u5FC5\u987B\u7B26\u5408' + item.pattern
        };
        if (!ret[key]) {
          ret[key] = [];
        }
        ret[key].push(rule);
      } else if (item.type === 'string') {
        var _rule = {
          trigger: 'blur'
        };
        var minLength = item.minLength;
        var maxLength = item.maxLength;
        if (typeof minLength === 'number') {
          _rule.min = minLength;
          _rule.message = '\u957F\u5EA6\u5FC5\u987B\u5927\u4E8E' + minLength + '\u4E2A\u5B57\u7B26';
        }
        if (typeof maxLength === 'number') {
          _rule.max = maxLength;
          if (typeof minLength === 'number') {
            _rule.message = '\u957F\u5EA6\u53EA\u80FD\u5728' + minLength + '-' + maxLength + '\u4E2A\u5B57\u7B26\u4E4B\u95F4';
          } else {
            _rule.message = '\u957F\u5EA6\u5FC5\u987B\u5C0F\u4E8E' + maxLength + '\u4E2A\u5B57\u7B26';
          }
        }
        if (_rule.message !== '' && _rule.message !== undefined) {
          if (!ret[key]) {
            ret[key] = [];
          }
          ret[key].push(_rule);
        }
      } else if (item.type === 'integer' || item.type === 'number') {
        var message = itemName + '\u5FC5\u987B\u4E3A\u6570\u5B57';
        if (item.type === 'integer') {
          message = itemName + '\u5FC5\u987B\u4E3A\u6574\u6570';
        }
        var numberRule = {
          type: item.type,
          message: message,
          trigger: 'blur'
        };
        var minimum = item.minimum;
        var maximum = item.maximum;
        if (typeof minimum === 'number') {
          numberRule.min = minimum;
          numberRule.message = '\u8BF7\u8F93\u5165\u5927\u4E8E' + minimum + '\u7684' + (item.type === 'integer' ? '整数' : '数字');
        }
        if (typeof maximum === 'number') {
          numberRule.max = maximum;
          if (typeof minimum === 'number') {
            numberRule.message = '\u8BF7\u8F93\u5165' + minimum + ' - ' + maximum + '\u4E4B\u95F4\u7684' + (item.type === 'integer' ? '整数' : '数字');
          } else {
            numberRule.message = '\u8BF7\u8F93\u5165\u5C0F\u4E8E' + maximum + '\u7684' + (item.type === 'integer' ? '整数' : '数字');
          }
        }
        var isRequiredRuleExist = false;
        if (!ret[key]) {
          ret[key] = [];
        } else {
          isRequiredRuleExist = ret[key].some(function (newRule) {
            // 因async-validator无法正常处理数字类型的required:true规则，
            // 因此暂时移除数字类型的required:true规则
            if (newRule.required === true) {
              newRule.type = item.type;
              return true;
            }
          });
        }
        if (isRequiredRuleExist) {
          // 在规则头部生成数字校验规则以规避上述问题
          ret[key].unshift(numberRule);
        } else {
          // 在规则末尾生成数字校验规则
          ret[key].push(numberRule);
        }
      }
    }
  });
  return ret;
}

/**
 * 转换为金额格式
 * @param {string | number} val
 */
function priceFormatter(val, config) {
  var current = '' + val;
  if (_lodash2.default.isEmpty(current)) {
    return val;
  }
  var format = function format(v) {
    var ret = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return ret;
  };
  if (current.indexOf('.')) {
    var arr = current.split('.');
    arr[0] = format(arr[0]);
    return arr.join('.');
  }
  return format(current);
}

/**
 * 将字符串格式金额转换为数字格式
 * @param {string} val
 * @returns
 */
function priceParser(val) {
  return val.replace(/(,*)/g, '');
}

/**
 * 根据property取得Element信息
 * @param {*} key
 * @param {*} property
 * @param {*} uiProperty
 * @param {*} model
 * @param {*} h
 * @returns
 */
function createElementByProperty(key, property, uiProperty, model, emit) {
  // 默认日期格式
  var DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
  var DEFAULT_DATE_TIME_FORMAT = DEFAULT_DATE_FORMAT + ' HH:mm:ss';
  // 默认时间格式
  var DEFAULT_TIME_FORMAT = 'HH:mm:ss';
  var componentProps = {};
  // const componentChildren = [];
  // title为空的场合
  if ((0, _util.isEmpty)(property.title)) {
    return componentProps;
  }
  var componentTagName = '';
  var props = {
    value: model[key]
  };
  if (typeof uiProperty[_index.JSON_FORM_UI.UI_DISABLED] === 'boolean') {
    props.disabled = uiProperty[_index.JSON_FORM_UI.UI_DISABLED];
  }
  // DOM 属性
  var domProps = {};
  // 普通的 HTML attribute
  var attrs = {};
  var events = {
    on: {},
    nativeOn: {}
  };
  var componentChildrenOptions = [];
  if (property.editable === false) {
    componentTagName = 'div';
    var formater = createFormatter(property);
    domProps.innerHTML = formater ? formater(props.value) : props.value;
  } else {
    // 因render 函数中没有与 v-model 相应的 api, 实现v-model逻辑。
    events.on.input = function (val) {
      model[key] = val;
      emit('input', key, val, model);
    };
    events.on.change = function (val) {
      emit('change', key, val, model);
    };
    if (property.enum || property.oneOf || property.anyOf) {
      if (property.oneOf && uiProperty[_index.JSON_FORM_UI.UI_WIDGET] === 'radio') {
        componentTagName = 'el-radio-group';
      } else if (property.anyOf && uiProperty[_index.JSON_FORM_UI.UI_WIDGET] === 'checkbox' && property.type === 'array') {
        componentTagName = 'el-checkbox-group';
      } else {
        componentTagName = 'el-select';
        props.multiple = false;
      }
      // 取得选择项一览
      var list = null;
      if (property.oneOf) {
        list = property.oneOf;
      } else if (property.anyOf) {
        list = property.anyOf;
        if (componentTagName === 'el-select') {
          props.multiple = true;
        }
      } else {
        list = property.enum.map(function (e) {
          return { title: e, 'const': e };
        });
      }
      var optionList = [];
      list.forEach(function (item) {
        optionList.push({
          label: item.title,
          value: item.const,
          disabled: item.disabled
        });
      });
      if (componentTagName === 'el-select') {
        optionList.forEach(function (item) {
          componentChildrenOptions.push({
            label: item.label,
            value: item.value,
            disabled: item.disabled
          });
        });
      } else if (componentTagName === 'el-radio-group') {
        optionList.forEach(function (item) {
          componentChildrenOptions.push({
            label: item.label,
            value: item.value
          });
        });
      } else if (componentTagName === 'el-checkbox-group') {
        optionList.forEach(function (item) {
          componentChildrenOptions.push({
            label: item.label,
            value: item.value
          });
        });
      }
    } else if (property.format === 'date' || property.format === 'date-time') {
      componentTagName = 'el-date-picker';
      if (property.type === 'string') {
        props.type = property.format.replace(/-/g, '');
      } else if (property.type === 'array') {
        props.type = (property.format + '-range').replace(/-/g, '');
      }
      if (uiProperty[_index.JSON_FORM_UI.UI_FORMAT] !== undefined && uiProperty[_index.JSON_FORM_UI.UI_FORMAT] !== null) {
        props['value-format'] = uiProperty[_index.JSON_FORM_UI.UI_FORMAT];
      } else if (property.format === 'date' || property.format === 'date-range') {
        props['value-format'] = DEFAULT_DATE_FORMAT;
      } else if (property.format === 'date-time' || property.format === 'date-time-range') {
        props['value-format'] = DEFAULT_DATE_TIME_FORMAT;
      }
    } else if (property.format === 'time') {
      componentTagName = 'el-time-picker';
      if (property.type === 'array') {
        props['is-range'] = true;
      }
      if (uiProperty[_index.JSON_FORM_UI.UI_FORMAT] !== undefined && uiProperty[_index.JSON_FORM_UI.UI_FORMAT] !== null) {
        props['value-format'] = uiProperty[_index.JSON_FORM_UI.UI_FORMAT];
      } else if (property.format === 'time' || property.format === 'time-range') {
        props['value-format'] = DEFAULT_TIME_FORMAT;
      }
    } else if (property.type === 'string') {
      componentTagName = 'el-input';
      // 组件类型
      var widgetType = uiProperty[_index.JSON_FORM_UI.UI_WIDGET];
      if (widgetType !== undefined) {
        if (widgetType === 'password') {
          props.type = 'password';
        } else if (widgetType === 'textarea') {
          props.type = 'textarea';
          var options = uiProperty[_index.JSON_FORM_UI.UI_OPTIONS] || {};
          if (typeof options.rows === 'number') {
            attrs.rows = options.rows;
          }
        }
      }
      if (typeof property.maxLength === 'number') {
        attrs.maxlength = property.maxLength;
      }
      componentProps.style = {
        width: '100%'
      };
    } else if (property.type === 'integer' || property.type === 'number') {
      events.on.input = function (val) {
        var ret = val;
        if (typeof val === 'string') {
          ret = parseFloat(val);
          if (isNaN(ret)) {
            ret = null;
          }
        }
        model[key] = ret;
        emit('input', key, ret, model);
      };
      var _options = uiProperty[_index.JSON_FORM_UI.UI_OPTIONS] || {};
      // 小数位
      var format = property.format,
          precision = property.precision,
          scale = property.scale;

      var scaleNum = _lodash2.default.toNumber(scale);
      if (typeof precision === 'number') {
        props.precision = precision;
      }
      // ui:options的precision属性为最优先
      var originPrecision = _lodash2.default.get(_options, 'precision', '');
      if (originPrecision === '' && _lodash2.default.isNumber(scaleNum) && !Number.isNaN(scaleNum)) {
        props.precision = scaleNum;
      }
      // 金额格式
      if (format === 'price') {
        var formatter = _lodash2.default.get(_options, 'formatter');
        // 没有进行自定义组件formatter属性的场合
        if (typeof formatter !== 'function') {
          var config = {};
          // 已定义小数位的场合
          if (_lodash2.default.isNumber(props.precision)) {
            config.maximumFractionDigits = props.precision;
          }
          props.formatter = function (val) {
            var result = priceFormatter(val, config);
            return result;
          };
        }
        var parser = _lodash2.default.get(_options, 'parser');
        // 没有进行自定义组件parser属性的场合
        if (typeof parser !== 'function') {
          props.parser = priceParser;
        }
      }
      componentTagName = 'el-input-number';
    } else if (property.type === 'boolean' && uiProperty[_index.JSON_FORM_UI.UI_WIDGET] === undefined) {
      componentTagName = 'el-checkbox';
    }
  }
  componentProps.props = props;
  componentProps.on = events.on;
  componentProps.nativeOn = events.nativeOn;
  if (Object.keys(domProps).length > 0) {
    componentProps.domProps = domProps;
  }
  // placeholder处理
  if ((0, _util.isEmpty)(attrs.placeholder)) {
    var placeholder = uiProperty[_index.JSON_FORM_UI.UI_PLACEHOLDER];
    if ((0, _util.isEmpty)(placeholder)) {
      placeholder = '\u8BF7\u8F93\u5165' + property.title;
    }
    attrs.placeholder = placeholder;
  }
  if (Object.keys(attrs).length > 0) {
    componentProps.attrs = attrs;
  }
  if (uiProperty[_index.JSON_FORM_UI.UI_ON]) {
    var uiOn = uiProperty[_index.JSON_FORM_UI.UI_ON];
    // 合并事件定义
    Object.keys(uiOn).forEach(function (uiOnKey) {
      // 自定义事件已被注册的场合，把注册的事件和自定义的事件按顺序执行
      if (typeof events.on[uiOnKey] === 'function') {
        events.on[uiOnKey] = function () {
          events.on[uiOnKey]();
          uiOn[uiOnKey]();
        };
      } else {
        events.on[uiOnKey] = uiOn[uiOnKey];
      }
    });
  }
  if (uiProperty[_index.JSON_FORM_UI.UI_NATIVE_ON]) {
    var uiNativeOn = uiProperty[_index.JSON_FORM_UI.UI_NATIVE_ON];
    // 合并事件定义
    Object.keys(uiNativeOn).forEach(function (uiOnKey) {
      // 自定义事件已被注册的场合，把注册的事件和自定义的事件按顺序执行
      if (typeof events.on[uiOnKey] === 'function') {
        events.nativeOn[uiOnKey] = function () {
          events.nativeOn[uiOnKey]();
          uiNativeOn[uiOnKey]();
        };
      } else {
        events.nativeOn[uiOnKey] = uiNativeOn[uiOnKey];
      }
    });
  }
  // 合并ui:options属性至组件属性中
  // 用户自定义的options属性为最优先
  var mergedProps = Object.assign({}, componentProps.props, uiProperty[_index.JSON_FORM_UI.UI_OPTIONS] || {});
  componentProps.props = mergedProps;
  return {
    componentTagName: componentTagName,
    componentProps: componentProps,
    componentChildrenOptions: componentChildrenOptions
  };
}

/**
 * 设置默认formatter
 */
function createFormatter(property) {
  var format = property.format,
      oneOf = property.oneOf,
      anyOf = property.anyOf,
      type = property.type,
      scale = property.scale;
  // 日期转换
  // if (format === 'date') {
  //   return function formatter(value) {
  //     if (_.isEmpty(value)) {
  //       return '';
  //     }
  //     return odataDateToString(value);
  //   };
  // }

  if (type === 'boolean') {
    return function formatter(value) {
      return value ? '是' : '否';
    };
  }
  if (format === 'time') {
    return function formatter(value) {
      if (_lodash2.default.isEmpty(value)) {
        return '';
      }
      return value;
    };
  }
  // 枚举值处理
  var dictList = oneOf || anyOf;
  if (!_lodash2.default.isEmpty(dictList)) {
    var getDisplayDictLabel = function getDisplayDictLabel(val) {
      var dict = _lodash2.default.find(dictList, function (item) {
        return item.const === val;
      });
      return dict ? dict.title : val;
    };
    return function formatter(value) {
      if (typeof value === 'string') {
        return getDisplayDictLabel(value);
      }
      if (Array.isArray(value)) {
        var res = value.map(function (cv) {
          var displayDictLabel = getDisplayDictLabel(cv);
          return displayDictLabel;
        }).join(', ');
        return res;
      }
      return value;
    };
  }
  if (format === 'price') {
    return function formatter(value) {
      var config = {};
      var scaleNum = _lodash2.default.toNumber(scale);
      if (typeof scaleNum === 'number') {
        config.maximumFractionDigits = scaleNum;
      } else {
        scaleNum = 0;
      }
      var val = _lodash2.default.toNumber(value);
      if (!_lodash2.default.isNumber) {
        return value;
      }
      var displayVal = priceFormatter(val, config);
      if (scaleNum === 0) {
        return displayVal;
      }
      // 因numeral在输入框内格式化值存在问题，且inputnumber组件会默认对小数位进行处理
      // 所以此处只处理只读状态下label的显示值
      if (_lodash2.default.isNumber(displayVal) && !_lodash2.default.isNaN(displayVal) || !_lodash2.default.isEmpty(displayVal) && displayVal !== 'NaN') {
        var digitVal = (0, _numeral2.default)(displayVal).value();
        digitVal = '' + digitVal.toFixed(scaleNum);
        return displayVal.split('.')[0] + '.' + digitVal.split('.')[1];
      }
      return value;
    };
  }
  // if (format === 'regex' && !isEmpty(pattern)) {
  //   return function formatter(value) {
  //   };
  // }
  return null;
}

function formatDate(odataDate, format) {
  if (!odataDate) {
    return '';
  }
  var temp = odataDate.match(/^\/Date\((.*)\)\/$/);
  if (!temp || !temp[1]) {
    return odataDate;
  }
  var timestamp = temp[1];
  if (!timestamp) {
    return '';
  }
  return (0, _moment2.default)(_lodash2.default.toNumber(timestamp)).format(format);
}

function dateFormatter(_ref) {
  var cellValue = _ref.cellValue;

  return formatDate(cellValue, 'YYYY-MM-DD');
}

function dateTimeFormatter(_ref2) {
  var cellValue = _ref2.cellValue;

  return formatDate(cellValue, 'YYYY-MM-DD HH:mm:ss');
}

function booleanFormatter(_ref3) {
  var cellValue = _ref3.cellValue;

  if (cellValue === null || cellValue === undefined) {
    return '';
  }
  if (cellValue === true || cellValue === 'true') {
    return '是';
  }
  return '否';
}

/**
 * 取得指定Property的初始值
 * @param {Object} property
 * @returns
 */
function getItemDefaultValue() {
  return null;
}

/**
 * 根据schema定义生成对应的初始化对象
 * @param {Object} schema
 * @returns
 */
function createDefaultObjectBySchema() {
  var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var ret = {};
  Object.keys(schema.properties).forEach(function (key) {
    ret[key] = getItemDefaultValue(schema.properties[key]);
  });
  return ret;
}

exports.default = {
  createElementByProperty: createElementByProperty,
  createFormRulesBySchema: createFormRulesBySchema,
  createDefaultObjectBySchema: createDefaultObjectBySchema
};